import { Injectable } from "@angular/core";
import { Headers, Http } from "@angular/http";
import { environment } from "../../../../../../environments/environment";
import { Observable } from "rxjs/Observable";
import { Header } from "primeng/primeng";

@Injectable()
export class CheckStampService {
  headers: Headers;
  headers2: Header;
  headers3: Headers;
  url = environment.qrcode_url;
  url_2 = environment.api_evs;

  constructor(private http: Http) {
    const token = localStorage.getItem("Access-Token");
    const token2 = localStorage.getItem("Access-Token-2");
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    this.headers2 = new Headers({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token2}`,
    });
    this.headers3 = new Headers({
      "Content-Type": "application/json",
      Authorization: `${token}`,
    })

  }

  getDetail(serial?: any): Observable<any> {
    return this.http
      .get(`${this.url}/stamp/code?code=${serial}`, { headers: this.headers })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }

  getValidator(serial?: any): Observable<any> {
    return this.http
      .get(`${this.url}/stamp/${serial}/validator`, { headers: this.headers })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }

  //  lich sử phân phối của 1 tem
  getStampHistory(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/transfer/stamp/history`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }
  getScanErr(data?: any): Observable<any> {
    return this.http
      .get(`${this.url_2}/qr-core-aps/scan-errors`, {
        headers: this.headers,
        params: data,
      })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }
  /** ----- Lịch sử bảo hành ------- */

  getStampHistoryGuarantee(serial?: any, data?: any): Observable<any> {
    return this.http.get(`${this.url_2}/guarantee/${serial}/logs`, {
        headers: this.headers3,
        params: data,
      })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }

  // Trạng thái bảo hành

  // updateGuaranteeStatusById(id: any, status: any, body: any = null) {
  //   return this.put("/guarantee/" + id + "/" + status, body);
  // }
  updateGuaranteeStatusById(logId: any, status: any, body:any =null) {
    return this.http.put(`${this.url_2}/guarantee/${logId}/${status}`,{
      headers:this.headers3,
      params:body,
    }).map((res) => {
      return res.json();
    })
    .catch((err) => {
      throw err.json();
    });
  }

  /** End bảo hành */
  // getLogGuaranteeBySerial(serial: any, data?: any) {
  //   return this.get(`/guarantee/${serial}/logs`, data);
  // }
  //  chi tiet tem trong thung
  getStaticStampOfBox(id?: string, query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/bundles/${id}/stamps/statistic`, {
        headers: this.headers,
        params: query,
      })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }
  getStampOfBox(id?: string, query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/bundles/${id}/stamps`, {
        headers: this.headers,
        params: query,
      })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }

  getTotalWarning(agencyId?: string): Observable<any> {
    return this.http
      .get(`${this.url}/market-inspection/warning/agency/${agencyId}`, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }

  createWarning(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/market-inspection`, body, { headers: this.headers })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }
  // ds canh bao tu kiem tra  thi truong
  getWarningMarket(query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/market-inspection`, {
        headers: this.headers,
        params: query,
      })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }
  // tao moi yeu cau tra hang
  createReturnStamp(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/transfer/request/return`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }
  // xoa tem khoi thung
  deleteStampOfbox(boxId?: any, body?: any): Observable<any> {
    return this.http
      .put(`${this.url}/box/stamps/${boxId}`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }
  // thu hoi tem thung
  takeBackStamp(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/transfer/stamp/take_back`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }
  // goong
  getPalceId(query?: any): Observable<any> {
    return this.http
      .get(`https://rsapi.goong.io/Place/AutoComplete`, { params: query })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }
  getLatLon(query?: any): Observable<any> {
    return this.http
      .get(`https://rsapi.goong.io/Place/Detail`, { params: query })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }
  // lich su quet tem san pham
  getHistoryScanStampProduct(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/scan/stamp/product/history`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }
  // lich su quet tem thung
  getHistoryScanStampBox(query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/box/scan`, { headers: this.headers, params: query })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/stamp_list/services/check-stamp.service.ts